import { Dayjs } from 'dayjs';
import { Job } from '@core/generated/gql-types';
import { usePriorWeekData } from '@/components/dashboard/usePriorWeekData';
import FilledJobs from './summaryCards/FilledJobs';
import FillRate from './summaryCards/FillRate';
import ActiveWorkers from './summaryCards/ActiveWorkers';
import HoursCompleted from './summaryCards/HoursCompleted';

interface JobsSummaryProps {
  filledJobs: Job[];
  unfilledJobs: Job[];
  timeframeStartDate: Dayjs | undefined;
}

const JobsSummary = ({
  filledJobs,
  unfilledJobs,
  timeframeStartDate,
}: JobsSummaryProps) => {
  // Only fetch prior week data for comparison metrics
  const { priorWeekFilledJobs } = usePriorWeekData(
    [...filledJobs, ...unfilledJobs],
    timeframeStartDate,
  );

  return (
    <div className="grid-row-2 grid grid-cols-2 flex-row gap-4">
      <FilledJobs filledJobs={filledJobs} unfilledJobs={unfilledJobs} />
      <FillRate
        filledJobs={filledJobs}
        unfilledJobs={unfilledJobs}
        priorWeekFilledJobs={priorWeekFilledJobs}
      />
      <ActiveWorkers
        filledJobs={filledJobs}
        priorWeekFilledJobs={priorWeekFilledJobs}
      />
      <HoursCompleted
        filledJobs={filledJobs}
        priorWeekFilledJobs={priorWeekFilledJobs}
      />
    </div>
  );
};

export default JobsSummary;
